window.slate = window.slate || {};
window.theme = window.theme || {};

// Track popup display
slate.popUpShown = false;
slate.browserWidth = 'small';

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

	/**
	 * For use when focus shifts to a container rather than a link
	 * eg for In-page links, after scroll, focus shifts to content area so that
	 * next `tab` is where user expects if focusing a link, just $link.focus();
	 *
	 * @param {JQuery} $element - The element to be acted upon
	 */
	pageLinkFocus: function($element) {
		var focusClass = 'js-focus-hidden';

		$element.first()
			.attr('tabIndex', '-1')
			.focus()
			.addClass(focusClass)
			.one('blur', callback);

		function callback() {
			$element.first()
				.removeClass(focusClass)
				.removeAttr('tabindex');
		}
	},

	/**
	 * If there's a hash in the url, focus the appropriate element
	 */
	focusHash: function() {
		var hash = window.location.hash;

		// is there a hash in the url? is it an element on the page?
		if (hash && document.getElementById(hash.slice(1))) {
			this.pageLinkFocus($(hash));
		}
	},

	/**
	 * When an in-page (url w/hash) link is clicked, focus the appropriate element
	 */
	bindInPageLinks: function() {
		$('a[href*=#]').on('click', function(evt) {
			this.pageLinkFocus($(evt.currentTarget.hash));
		}.bind(this));
	},

	/**
	 * Traps the focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	trapFocus: function(options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (!options.$elementToFocus) {
			options.$elementToFocus = options.$container;
		}

		options.$container.attr('tabindex', '-1');
		options.$elementToFocus.focus();

		$(document).on(eventName, function(evt) {
			if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
				options.$container.focus();
			}
		});
	},

	/**
	 * Removes the trap of focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	removeTrapFocus: function(options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (options.$container && options.$container.length) {
			options.$container.removeAttr('tabindex');
		}

		$(document).off(eventName);
	}
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
	
	/**
	 * Browser cookies are required to use the cart. This function checks if
	 * cookies are enabled in the browser.
	 */
	cookiesEnabled: function() {
		var cookieEnabled = navigator.cookieEnabled;

		if (!cookieEnabled){
			document.cookie = 'testcookie';
			cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
		}
		return cookieEnabled;
	}
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

	/**
	 * Return an object from an array of objects that matches the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	findInstance: function(array, key, value) {
		for (var i = 0; i < array.length; i++) {
			if (array[i][key] === value) {
				return array[i];
			}
		}
	},

	/**
	 * Remove an object from an array of objects by matching the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	removeInstance: function(array, key, value) {
		var i = array.length;
		while(i--) {
			if (array[i][key] === value) {
				array.splice(i, 1);
				break;
			}
		}

		return array;
	},

	/**
	 * _.compact from lodash
	 * Remove empty/false items from array
	 * Source: https://github.com/lodash/lodash/blob/master/compact.js
	 *
	 * @param {array} array
	 */
	compact: function(array) {
		var index = -1;
		var length = array == null ? 0 : array.length;
		var resIndex = 0;
		var result = [];

		while (++index < length) {
			var value = array[index];
			if (value) {
				result[resIndex++] = value;
			}
		}
		return result;
	},

	/**
	 * _.defaultTo from lodash
	 * Checks `value` to determine whether a default value should be returned in
	 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	 * or `undefined`.
	 * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
	 *
	 * @param {*} value - Value to check
	 * @param {*} defaultValue - Default value
	 * @returns {*} - Returns the resolved value
	 */
	defaultTo: function(value, defaultValue) {
		return (value == null || value !== value) ? defaultValue : value
	}
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
	/**
	 * Wrap tables in a container div to make them scrollable when needed
	 *
	 * @param {object} options - Options to be used
	 * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
	 * @param {string} options.tableWrapperClass - table wrapper class name
	 */
	wrapTable: function(options) {
		var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

		options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
	},

	/**
	 * Wrap iframes in a container div to make them responsive
	 *
	 * @param {object} options - Options to be used
	 * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
	 * @param {string} options.iframeWrapperClass - class name used on the wrapping div
	 */
	wrapIframe: function(options) {
		var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

		options.$iframes.each(function() {
			// Add wrapper to make video responsive
			$(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
			
			// Re-set the src attribute on each iframe after page load
			// for Chrome's "incorrect iFrame content on 'back'" bug.
			// https://code.google.com/p/chromium/issues/detail?id=395791
			// Need to specifically target video and admin bar
			this.src = this.src;
		});
	}
};

slate.Sections = function Sections() {
	this.constructors = {};
	this.instances = [];

	$(document)
		.on('shopify:section:load', this._onSectionLoad.bind(this))
		.on('shopify:section:unload', this._onSectionUnload.bind(this))
		.on('shopify:section:select', this._onSelect.bind(this))
		.on('shopify:section:deselect', this._onDeselect.bind(this))
		.on('shopify:section:reorder', this._onReorder.bind(this))
		.on('shopify:block:select', this._onBlockSelect.bind(this))
		.on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
	_createInstance: function(container, constructor) {
		var $container = $(container);
		var id = $container.attr('data-section-id');
		var type = $container.attr('data-section-type');

		constructor = constructor || this.constructors[type];

		if (typeof constructor === 'undefined') {
			return;
		}

		var instance = $.extend(new constructor(container), {
			id: id,
			type: type,
			container: container
		});

		this.instances.push(instance);
	},

	_onSectionLoad: function(evt) {
		var container = $('[data-section-id]', evt.target)[0];
		if (container) {
			this._createInstance(container);
		}
	},

	_onSectionUnload: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (!instance) {
			return;
		}

		if (typeof instance.onUnload === 'function') {
			instance.onUnload(evt);
		}

		this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
	},

	_onSelect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onSelect === 'function') {
			instance.onSelect(evt);
		}
	},

	_onDeselect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onDeselect === 'function') {
			instance.onDeselect(evt);
		}
	},

	_onReorder: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onReorder === 'function') {
			instance.onReorder(evt);
		}
	},

	_onBlockSelect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onBlockSelect === 'function') {
			instance.onBlockSelect(evt);
		}
	},

	_onBlockDeselect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onBlockDeselect === 'function') {
			instance.onBlockDeselect(evt);
		}
	},

	register: function(type, constructor) {
		this.constructors[type] = constructor;

		$('[data-section-type=' + type + ']').each(function(index, container) {
			this._createInstance(container, constructor);
		}.bind(this));
	}
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
	var moneyFormat = '${{amount}}';

	/**
	 * Format money values based on your shop currency settings
	 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
	 * or 3.00 dollars
	 * @param  {String} format - shop money_format setting
	 * @return {String} value - formatted value
	 */
	function formatMoney(cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || moneyFormat);

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = slate.utils.defaultTo(precision, 2);
			thousands = slate.utils.defaultTo(thousands, ',');
			decimal = slate.utils.defaultTo(decimal, '.');

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split('.');
			var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
			var centsAmount = parts[1] ? (decimal + parts[1]) : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, ',', '.');
				break;
			case 'amount_with_space_separator':
				value = formatWithDelimiters(cents, 2, ' ', '.');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
			case 'amount_no_decimals_with_space_separator':
				value = formatWithDelimiters(cents, 0, ' ');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	}

	return {
		formatMoney: formatMoney
	};
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

	/**
	 * Preloads an image in memory and uses the browsers cache to store it until needed.
	 *
	 * @param {Array} images - A list of image urls
	 * @param {String} size - A shopify image size attribute
	 */

	function preload(images, size) {
		if (typeof images === 'string') {
			images = [images];
		}

		for (var i = 0; i < images.length; i++) {
			var image = images[i];
			this.loadImage(this.getSizedImageUrl(image, size));
		}
	}

	/**
	 * Loads and caches an image in the browsers cache.
	 * @param {string} path - An image url
	 */
	function loadImage(path) {
		new Image().src = path;
	}

	/**
	 * Find the Shopify image attribute size
	 *
	 * @param {string} src
	 * @returns {null}
	 */
	function imageSize(src) {
		var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

		if (match) {
			return match[1];
		} else {
			return null;
		}
	}

	/**
	 * Adds a Shopify size attribute to a URL
	 *
	 * @param src
	 * @param size
	 * @returns {*}
	 */
	function getSizedImageUrl(src, size) {
		if (size === null) {
			return src;
		}

		if (size === 'master') {
			return this.removeProtocol(src);
		}

		var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
		var match_asset = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?\d+)?$/i);

		if (match) {
			var prefix = src.split(match[0]);
			var suffix = match[0];

			return this.removeProtocol(prefix[0] + '_' + size + suffix);
		} else if(match_asset) {
			var prefix = src.split(match_asset[0]);
			var suffix = match_asset[0];

			return this.removeProtocol(prefix[0] + '_' + size + suffix);
		} else {
			return null;
		}
	}

	function removeProtocol(path) {
		return path.replace(/http(s)?:/, '');
	}

	return {
		preload: preload,
		loadImage: loadImage,
		imageSize: imageSize,
		getSizedImageUrl: getSizedImageUrl,
		removeProtocol: removeProtocol
	};
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

	/**
	 * Variant constructor
	 *
	 * @param {object} options - Settings from `product.js`
	 */
	function Variants(options) {
		this.$container = options.$container;
		this.product = options.product;
		this.singleOptionSelector = options.singleOptionSelector;
		this.originalSelectorId = options.originalSelectorId;
		this.enableHistoryState = options.enableHistoryState;
		this.currentVariant = this._getVariantFromOptions();

		$(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
	}

	Variants.prototype = $.extend({}, Variants.prototype, {

		/**
		 * Get the currently selected options from add-to-cart form. Works with all
		 * form input elements.
		 *
		 * @return {array} options - Values of currently selected variants
		 */
		_getCurrentOptions: function() {
			var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
				var $element = $(element);
				var type = $element.attr('type');
				var currentOption = {};

				if (type === 'radio' || type === 'checkbox') {
					if ($element[0].checked) {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');

						return currentOption;
					} else {
						return false;
					}
				} else {
					currentOption.value = $element.val();
					currentOption.index = $element.data('index');

					return currentOption;
				}
			});

			// remove any unchecked input values if using radio buttons or checkboxes
			currentOptions = slate.utils.compact(currentOptions);

			return currentOptions;
		},

		/**
		 * Find variant based on selected values.
		 *
		 * @param  {array} selectedValues - Values of variant inputs
		 * @return {object || undefined} found - Variant object from product.variants
		 */
		_getVariantFromOptions: function() {
			var selectedValues = this._getCurrentOptions();
			var variants = this.product.variants;
			var found = false;

			variants.forEach(function(variant) {
				var satisfied = true;

				selectedValues.forEach(function(option) {
					if (satisfied) {
						satisfied = (option.value === variant[option.index]);
					}
				});

				if (satisfied) {
					found = variant;
				}
			});

			return found || null;
		},

		/**
		 * Event handler for when a variant input changes.
		 */
		_onSelectChange: function() {
			var variant = this._getVariantFromOptions();

			this.$container.trigger({
				type: 'variantChange',
				variant: variant
			});

			if (!variant) {
				return;
			}

			this._updateMasterSelect(variant);
			this._updateImages(variant);
			this._updatePrice(variant);
			this._updateVariantInventory(variant);
			this.currentVariant = variant;

			if (this.enableHistoryState) {
				this._updateHistoryState(variant);
			}
		},

		/**
		 * Trigger event when variant image changes
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event}  variantImageChange
		 */
		_updateImages: function(variant) {
			var variantImage = variant.featured_image || {};
			var currentVariantImage = this.currentVariant.featured_image || {};

			if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
				return;
			}

			this.$container.trigger({
				type: 'variantImageChange',
				variant: variant
			});
		},

		/**
		 * Trigger event when variant price changes.
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event} variantPriceChange
		 */
		_updatePrice: function(variant) {
			if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
				return;
			}

			this.$container.trigger({
				type: 'variantPriceChange',
				variant: variant
			});
		},

		/**
		 * Update history state for product deeplinking
		 *
		 * @param {object} variant - Currently selected variant
		 */
		_updateHistoryState: function(variant) {
			if (!history.replaceState || !variant) {
				return;
			}

			var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
			window.history.replaceState({path: newurl}, '', newurl);
		},

		/**
		 * Update hidden master select of variant change
		 *
		 * @param {object} variant - Currently selected variant
		 */
		_updateMasterSelect: function(variant) {
			$(this.originalSelectorId, this.$container)[0].value = variant.id;
		},

		/**
		 * Update product inventory
		 *
		 * @params {object} variant - Currently selected varaint
		 */
		_updateVariantInventory: function (variant) {
			// Just make sure it will show
			$('.variant-inventory-block', this.$container).removeClass('hide');

			if (variant.inventory <= 3) {
				let qty = variant.inventory >= 0 ? variant.inventory : 0;
				let option = variant.option2 || variant.option1;
				$('.variant-inventory-block .inventory', this.$container).html(`${qty} item in size ${option} left`);
			} else {
				$('.variant-inventory-block .inventory', this.$container).html('&nbsp;');
			}
		}
	});

	return Variants;
})();

slate.LibraryLoader = (function() {
	var types = {
		link: 'link',
		script: 'script'
	};

	var status = {
		requested: 'requested',
		loaded: 'loaded'
	};

	var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

	var libraries = {
		youtubeSdk: {
			tagId: 'youtube-sdk',
			src: 'https://www.youtube.com/iframe_api',
			type: types.script
		},
		plyrShopifyStyles: {
			tagId: 'plyr-shopify-styles',
			src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
			type: types.link
		},
		modelViewerUiStyles: {
			tagId: 'shopify-model-viewer-ui-styles',
			src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
			type: types.link
		}
	};

	function load(libraryName, callback) {
		var library = libraries[libraryName];

		if (!library) return;
		if (library.status === status.requested) return;

		callback = callback || function() {};
		if (library.status === status.loaded) {
			callback();
			return;
		}

		library.status = status.requested;

		var tag;

		switch (library.type) {
			case types.script:
				tag = createScriptTag(library, callback);
				break;
			case types.link:
				tag = createLinkTag(library, callback);
				break;
		}

		tag.id = library.tagId;
		library.element = tag;

		var firstScriptTag = document.getElementsByTagName(library.type)[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	function createScriptTag(library, callback) {
		var tag = document.createElement('script');
		tag.src = library.src;
		tag.addEventListener('load', function() {
			library.status = status.loaded;
			callback();
		});
		return tag;
	}

	function createLinkTag(library, callback) {
		var tag = document.createElement('link');
		tag.href = library.src;
		tag.rel = 'stylesheet';
		tag.type = 'text/css';
		tag.addEventListener('load', function() {
			library.status = status.loaded;
			callback();
		});
		return tag;
	}

	return {
		load: load
	};
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
	 * @namespace product
 */

theme.Product = (function() {

	var selectors = {
		addToCart: '[data-add-to-cart]',
		addToCartText: '[data-add-to-cart-text]',
		comparePrice: '[data-compare-price]',
		comparePriceText: '[data-compare-text]',
		originalSelectorId: '[data-product-select]',
		priceWrapper: '[data-price-wrapper]',
		payLater: '.pay-later',
		productFeaturedImage: '[data-product-featured-image]',
		productJson: '[data-product-json]',
		productInventory: '[data-product-inventory]',
		productPrice: '[data-product-price]',
		productPriceLaybuy: '[data-product-price-laybuy]',
		productPriceAfterpay: '[data-product-price-afterpay]',
		singleOptionSelector: '[data-single-option-selector]',
		productMediaTypeVideo: '[data-product-media-type-video]',
		storeAvailabilitySelectorId: '[data-store-availability-select]'
	};

	/**
	 * Product section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function Product(container) {
		this.$container = $(container);

		// Stop parsing if we don't have the product json script tag when loading
		// section in the Theme Editor
		if (!$(selectors.productJson, this.$container).html()) {
			return;
		}

		var sectionId = this.$container.attr('data-section-id');
		this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
		// Get inventory from template -> inject to produc Object
		let inventories = JSON.parse($(selectors.productInventory, this.$container).html());
		this.productSingleObject.variants.forEach(function(v) {
			v.inventory = inventories[v.id.toString()] || 0
		})
		// Remove the "hide" class for inventory block when variant id present in URL
		if (window.location.search !== '' && window.location.search.includes('variant=')) {
			$('.variant-inventory-block', this.$container).removeClass('hide')
		}

		var options = {
			$container: this.$container,
			enableHistoryState: this.$container.data('enable-history-state') || false,
			singleOptionSelector: selectors.singleOptionSelector,
			originalSelectorId: selectors.originalSelectorId,
			product: this.productSingleObject
		};

		this.settings = {
			sectionId: sectionId
		};

		this.namespace = '.product';
		this.variants = new slate.Variants(options);
		this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

		this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
		this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

		if (this.$featuredImage.length > 0) {
			this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
			slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

			this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
		}

		// inject tag on the image
		this.initialBadge()

		this.initProductVideo();
		theme.StoreAvailability.init();
		this.preselectFirstVariant();

		// Initialize sticky add to cart
		this.initStickyAddToCart();
	}

	Product.prototype = $.extend({}, Product.prototype, {

		/**
		 * Updates the DOM state of the add to cart button
		 *
		 * @param {boolean} enabled - Decides whether cart is enabled or disabled
		 * @param {string} text - Updates the text notification content of the cart
		 */
		updateAddToCartState: function(evt) {
			var variant = evt.variant;

			if (variant) {
				$(selectors.priceWrapper, this.$container).removeClass('hide');
				$(selectors.payLater, this.$container).removeClass('hide');
				$(selectors.storeAvailabilitySelectorId).val(variant.id);
				theme.StoreAvailability.loadStores(variant.id);
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
				$(selectors.priceWrapper, this.$container).addClass('hide');
				$(selectors.payLater, this.$container).addClass('hide');
				return;
			}

			if (variant.available) {
				$(selectors.addToCart, this.$container).prop('disabled', false);
				$(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
			}
		},

		/**
		 * Updates the DOM with specified prices
		 *
		 * @param {string} productPrice - The current price of the product
		 * @param {string} comparePrice - The original price of the product
		 */
		updateProductPrices: function(evt) {
			var variant = evt.variant;
			var $payLater = $(selectors.payLater, this.$container);
			var $comparePrice = $(selectors.comparePrice, this.$container);
			var $laybuyPrice = $(selectors.productPriceLaybuy, this.$container);
			var $afterpayPrice = $(selectors.productPriceAfterpay, this.$container);
			var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

			$(selectors.productPrice, this.$container)
				.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
			$laybuyPrice.html(slate.Currency.formatMoney((variant.price / 6), theme.moneyFormat));
			$afterpayPrice.html(slate.Currency.formatMoney((variant.price / 4), theme.moneyFormat));
			$payLater.removeClass('hide');

			if (variant.compare_at_price > variant.price) {
				$comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
				$compareEls.removeClass('hide');
			} else {
				$comparePrice.html('');
				$compareEls.addClass('hide');
			}
		},

		/**
		 * Updates the DOM with the specified image URL
		 *
		 * @param {string} src - Image src URL
		 */
		updateProductImage: function(evt) {
			var variant = evt.variant;
			var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

			this.$featuredImage.attr('src', sizedImgUrl);
		},

		initProductVideo: function() {
			var sectionId = this.settings.sectionId;

			$(selectors.productMediaTypeVideo, this.$container).each(function() {
				var $el = $(this);
				theme.ProductVideo.init($el, sectionId);
			});
		},

		preselectFirstVariant: function() {
			const firstInStock = this.productSingleObject.variants.find(function(variant) {
				return variant.id;
			});
			if (!firstInStock) return;
			const firstVariantSelector = this.$container.find(
				`${selectors.singleOptionSelector}[data-variant-id="${firstInStock.id}"]`
			);
			firstVariantSelector?.trigger('click');
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function() {
			this.$container.off(this.namespace);
			theme.ProductVideo.removeSectionVideos(this.settings.sectionId);

			if (this.$stickyBar) {
				this.$stickyBar.find('[data-sticky-add-to-cart]').off('click');
			}
		},

		/**
		 * Inject `selling fast` badge on the image top left
		 */
		initialBadge: function () {
			let qos = 0;
			this.productSingleObject.variants.forEach((v) => {
				qos += (v?.inventory && v.inventory >= 0) ? v.inventory : 0
			})

			if (11 <= qos && qos <= 30) this.$container.find('.product-images')[0].insertAdjacentHTML('beforeEnd', '<div class="badge"><span>selling fast</span></div>')
		},

		/**
		 * Initialize sticky add to cart functionality
		 */
		initStickyAddToCart: function() {
			this.$stickyBar = $('#stickyAtcBar');

			if (!this.$stickyBar.length) return;

			// Get the main add to cart button to observe
			let $mainAtcButton = $(selectors.addToCart, this.$container);

			if (!$mainAtcButton.length) return;

			// Setup intersection observer
			let observer = new IntersectionObserver(function(entries) {
				entries.forEach(function(entry) {
					let buttonTop = $mainAtcButton.offset().top;
					let scrollTop = $(window).scrollTop();

					// Show/hide sticky bar
					if (!entry.isIntersecting && scrollTop > buttonTop) {
						this.$stickyBar.addClass('is-visible');
					} else {
						this.$stickyBar.removeClass('is-visible');
					}
				}.bind(this));
			}.bind(this), {
				threshold: 0,
				rootMargin: '0px'
			});

			observer.observe($mainAtcButton[0]);

			// Sync sticky button with main form
			this.$stickyBar.find('[data-sticky-add-to-cart]').on('click', function(e) {
				e.preventDefault();
				this.handleStickyAddToCart();
			}.bind(this));

			// Handle edit variant click
			this.$stickyBar.find('[data-sticky-edit-variant]').on('click', function(e) {
				e.preventDefault();
				this.scrollToProductVariants();
			}.bind(this));

			// Update sticky bar on variant change
			this.$container.on('variantChange' + this.namespace, function(evt) {
				this.updateStickyBar(evt.variant);
			}.bind(this));

			// Update sticky price on price change
			this.$container.on('variantPriceChange' + this.namespace, function(evt) {
				this.updateStickyPrice(evt.variant);
			}.bind(this));

			// Initialize sticky variant size with current variant
			let currentVariant = this.productSingleObject.selected_or_first_available_variant ||
				this.productSingleObject.variants[0];
			if (currentVariant) {
				this.updateStickyVariantSize(currentVariant);
			}
		},

		/**
		 * Handle sticky add to cart button click
		 */
		handleStickyAddToCart: function() {
			let $mainForm = $('.add-to-cart-form', this.$container);
			let variantId = $mainForm.find('[name="id"]').val();

			if (!variantId) return;

			// Submit the main form
			$mainForm.submit();

			// Smoother scroll to top before minicart opens
			$('html, body').animate({
				scrollTop: 0
			}, 500);
		},

		/**
		 * Update sticky bar when variant changes
		 */
		updateStickyBar: function(variant) {
			let $stickyButton = this.$stickyBar.find('[data-sticky-add-to-cart]');

			if (!variant) {
				$stickyButton.prop('disabled', true);
				$stickyButton.find('span').text(theme.strings.unavailable);
				return;
			}

			if (variant.available) {
				$stickyButton.prop('disabled', false);
				$stickyButton.find('span').text(theme.strings.addToCart);
			} else {
				$stickyButton.prop('disabled', true);
				$stickyButton.find('span').text(theme.strings.soldOut);
			}

			// Update image if variant has featured image
			if (variant.featured_image) {
				let imageUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, '100x100');
				this.$stickyBar.find('.sticky-product-image img').attr('src', imageUrl);
			}

			// Update variant size display
			this.updateStickyVariantSize(variant);
		},

		/**
		 * Update sticky price display
		 */
		updateStickyPrice: function(variant) {
			this.$stickyBar.find('[data-sticky-price]')
				.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
		},

		/**
		 * Update sticky variant size display
		 */
		updateStickyVariantSize: function(variant) {
			let $stickyVariantSize = this.$stickyBar.find('[data-sticky-variant-size]');

			if (!$stickyVariantSize.length || !variant) {
				return;
			}

			// Get the size option value, fallback to option1
			let size = variant.option2 || variant.option1 || '';

			// Update the size display
			if (size) {
				$stickyVariantSize.text(size + ', ');
			} else {
				$stickyVariantSize.text('');
			}
		},

		/**
		 * Scroll to the product variants section
		 */
		scrollToProductVariants: function() {
			let $productVariants = this.$container.find('.product-main .product-details');

			if ($productVariants.length) {
				$('html, body').animate({
					scrollTop: $productVariants.offset().top - 100
				}, 500);
			}
		}
	});

	return Product;
})();

theme.ProductVideo = (function() {
	var videos = {};

	var hosts = {
		html5: 'html5',
		youtube: 'youtube'
	};

	var selectors = {
		productMediaWrapper: '[data-product-single-media-wrapper]'
	};

	var attributes = {
		enableVideoLooping: 'enable-video-looping',
		videoId: 'video-id'
	};

	function init(videoContainer, sectionId) {
		if (!videoContainer.length) {
			return;
		}

		var videoElement = videoContainer.find('iframe, video')[0];
		var mediaId = videoContainer.data('mediaId');

		if (!videoElement) {
			return;
		}

		videos[mediaId] = {
			mediaId: mediaId,
			sectionId: sectionId,
			host: hostFromVideoElement(videoElement),
			container: videoContainer,
			element: videoElement,
			ready: function() {
				createPlayer(this);
			}
		};

		var video = videos[mediaId];

		switch (video.host) {
			case hosts.html5:
				window.Shopify.loadFeatures([
					{
						name: 'video-ui',
						version: '1.0',
						onLoad: setupPlyrVideos
					}
				]);
				slate.LibraryLoader.load('plyrShopifyStyles');
				break;
			case hosts.youtube:
				slate.LibraryLoader.load('youtubeSdk', setupYouTubeVideos);
				break;
		}
	}

	function setupPlyrVideos(errors) {
		if (errors) {
			fallbackToNativeVideo();
			return;
		}

		loadVideos(hosts.html5);
	}

	function setupYouTubeVideos() {
		if (!window.YT.Player) return;

		loadVideos(hosts.youtube);
	}

	function createPlayer(video) {
		if (video.player) {
			return;
		}

		var productMediaWrapper = video.container.closest(
			selectors.productMediaWrapper
		);
		var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

		switch (video.host) {
			case hosts.html5:
				// eslint-disable-next-line no-undef
				video.player = new Shopify.Plyr(video.element, {
					loop: { active: enableLooping }
				});
				break;
			case hosts.youtube:
				var videoId = productMediaWrapper.data(attributes.videoId);

				video.player = new YT.Player(video.element, {
					videoId: videoId,
					events: {
						onStateChange: function(event) {
							if (event.data === 0 && enableLooping) event.target.seekTo(0);
						}
					}
				});
				break;
		}

		productMediaWrapper.on('mediaHidden xrLaunch', function() {
			if (!video.player) return;

			if (video.host === hosts.html5) {
				video.player.pause();
			}

			if (video.host === hosts.youtube && video.player.pauseVideo) {
				video.player.pauseVideo();
			}
		});

		productMediaWrapper.on('mediaVisible', function() {
			if(Modernizr.touchevents) return;
			if (!video.player) return;

			if (video.host === hosts.html5) {
				video.player.play();
			}

			if (video.host === hosts.youtube && video.player.playVideo) {
				video.player.playVideo();
			}
		});
	}

	function hostFromVideoElement(video) {
		if (video.tagName === 'VIDEO') {
			return hosts.html5;
		}

		if (video.tagName === 'IFRAME') {
			if (
				/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
					video.src
				)
			) {
				return hosts.youtube;
			}
		}
		return null;
	}

	function loadVideos(host) {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];
				if (video.host === host) {
					video.ready();
				}
			}
		}
	}

	function fallbackToNativeVideo() {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];

				if (video.nativeVideo) continue;

				if (video.host === hosts.html5) {
					video.element.setAttribute('controls', 'controls');
					video.nativeVideo = true;
				}
			}
		}
	}

	function removeSectionVideos(sectionId) {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];

				if (video.sectionId === sectionId) {
					if (video.player) video.player.destroy();
					delete videos[key];
				}
			}
		}
	}

	return {
		init: init,
		hosts: hosts,
		loadVideos: loadVideos,
		removeSectionVideos: removeSectionVideos
	};
})();

theme.StoreAvailability = (function() {
	// Private general variables
	var inventoryData;

	var selectors = {
		storeAvailabilityPopup: '[data-store-availability-popup]',
		storeAvailabilityList: '[data-store-availability-list]',
		storeAvailabilitySelect: '[data-store-availability-select]'
	};

	function init() {
		var productID = $(selectors.storeAvailabilitySelect).data('product-id'),
				selectedVariant = $(selectors.storeAvailabilitySelect).val(),
				variantOptions = $('.single-option-radio');

		inventoryData = null;

		$(selectors.storeAvailabilitySelect).on('change', function() {
			var variant = $(this).val();

			if(variant) {
				loadStores(variant);
			} else {
				$(selectors.storeAvailabilityList).addClass('hide');
			}
		});

		if(productID) {
			var options = {
				type: 'GET',
				url: '/a/ps-1/shopify/product/' + productID,
				timeout: 0
			};

			$.ajax(options).done(function (response) {
				if(response.message == 'success') {
					inventoryData = response.data;

					// Recalculate the inventories for each variants
					Object.keys(inventoryData.variants).forEach((vid) => {
						let negative_num = 0
						inventoryData.locations.forEach(local => {
							if (local.inventories[vid] !== undefined && typeof(local.inventories[vid]) !== 'string') {
								local.inventories[vid] < 0 ? negative_num += local.inventories[vid] : null
							}
						})
						if (negative_num >= 0) return
						inventoryData.locations.some(local => {
							if (local.inventories[vid] > 0) {
								local.inventories[vid] += negative_num
								if (local.inventories[vid] >= 0) {
									negative_num = 0
								} else {
									negative_num = local.inventories[vid]
									local.inventories[vid] = 0
								}
							}
							return negative_num === 0
						})
					})


					if(selectedVariant) {
						loadStores(selectedVariant);
					}
				} else {
          fetchProductFallback();
        }
			}).done(() => {
				variantOptions.removeClass('loading');
			}).fail(function() {
        fetchProductFallback();
      });

      function fetchProductFallback() {
        variantOptions.removeClass('loading');
        $('.trigger-store-popup').hide();
      }
		}
	}



	function loadStores(variant) {
		if(inventoryData !== null) {
			// Start with a fresh div
			$(selectors.storeAvailabilityList).empty();

			// Handlebars.js layout
			var stores = [],
				store = {},
				data = {},
				source = $("#StoreAvailabilityTemplate").html(),
				template = Handlebars.compile(source),
				checkInStoreBtn = $('.trigger-store-popup');

			// Add each store to our handlebars.js data
			$.each(inventoryData.locations, function(index, storeItem) {
				var inStock = false,
				lowStock = false,
				noStock = false;

				$.each(storeItem.inventories, function(key, storeInventory) {
					if(key == variant) {
						if(storeInventory == 'In stock' || storeInventory >= 3) {
							inStock = true;
						} else if(storeInventory == 'Low stock' || (storeInventory > 0 && storeInventory < 3)) {
							lowStock = true;
						} else if(storeInventory == 'No stock' || storeInventory <= 0) {
							noStock = true;
						}
						return false;
					}
				});

				// Create store's data object and add to 'stores' array
				store = {
					title: storeItem.displayName,
					inStock: inStock,
					lowStock: lowStock,
					noStock: noStock
				};
				stores.push(store);
			});

			// Gather all cart data and add to DOM
			data = {
				stores: stores
			}

			$(selectors.storeAvailabilityList).removeClass('hide').append(template(data));
			checkInStoreBtn.removeClass('disabled');
		}
	}

	return {
		init: init,
		loadStores: loadStores
	};
})();

theme.ProductRecommendations = (function() {
	function ProductRecommendations(container) {
		this.$container = $(container);

		var baseUrl = this.$container.data('baseUrl');
		var productId = this.$container.data('productId');
		var productsToShow = this.$container.data('productsToShow');
		var recommendationsSectionUrl =
			baseUrl +
			'?section_id=product-recommendations&product_id=' +
			productId +
			'&limit=' +
			productsToShow;

		$.get(recommendationsSectionUrl).then(
			function(section) {
				var recommendationsMarkup = $(section).html();
				if (recommendationsMarkup.trim() !== '') {
					this.$container.hide();
					this.$container.html(recommendationsMarkup);

					var placeholder = $('#product-recommendations-placeholder');
					if (placeholder.length) {
						placeholder.html(this.$container.prop('outerHTML'));
						placeholder.find('aside').show();
						var $carousel = placeholder.find('.carousel');
					}
					else {
						this.$container.show();
						var $carousel = this.$container.find('.carousel');
					}

					if($carousel.length) {
						new ScrollCarousel($carousel[0]).init();
					}
				} else {
					this.$container.hide();
				}
			}.bind(this)
		);
	}

	return ProductRecommendations;
})();


/*================ Templates ================*/
/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
	var config = {
		recoverPasswordForm: '#RecoverPassword',
		hideRecoverPasswordLink: '#HideRecoverPasswordLink'
	};

	if (!$(config.recoverPasswordForm).length) {
		return;
	}

	checkUrlHash();
	resetPasswordSuccess();

	$(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
	$(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

	function onShowHidePasswordForm(evt) {
		evt.preventDefault();
		toggleRecoverPasswordForm();
	}

	function checkUrlHash() {
		var hash = window.location.hash;

		// Allow deep linking to recover password form
		if (hash === '#recover') {
			toggleRecoverPasswordForm();
		}
	}

	/**
	 *  Show/Hide recover password form
	 */
	function toggleRecoverPasswordForm() {
		$('#RecoverPasswordForm').toggleClass('hide');
		$('#CustomerLoginForm').toggleClass('hide');
	}

	/**
	 *  Show reset password success message
	 */
	function resetPasswordSuccess() {
		var $formState = $('.reset-password-success');

		// check if reset password form was successfully submited.
		if (!$formState.length) {
			return;
		}

		// show success message
		$('#ResetSuccess').removeClass('hide');
	}
})();

/**
 * Global Script for Similar Styling
 * ------------------------------------------------------------------------------
 *
 */
(function() {
	let configs = document.querySelector('script#SimilarStyling');
	const styling_doms = document.querySelectorAll('.similar-styles.liquid');
	const vendor_mapping2 = {'moochi': "m o o c h i", '6&7': "six & seven", 'bread&butter': "bread & butter"};
	if (!configs || styling_doms.length == 0) return
	configs = JSON.parse(configs.innerText);
	styling_doms.forEach(function(dom) {
		let match = configs[dom.dataset.type] || null;
		if (!match) return
		match = match[dom.dataset.vendor] || null;
		if (!match) return
		match = match[dom.dataset.colour] || null;
		if (!match) return
		// Mapping vendor
		match['params'].map(function(param) {
			if (param['key'] !== 'pf_v_label') return param
			param['value'] = vendor_mapping2[param['value']] || param['value']
			return param
		})
		dom.classList.remove('hide')
		dom.addEventListener('click', function(e) {
			e.preventDefault();
			window.sessionStorage.setItem('similar_styling', JSON.stringify(match))
			window.location.href = '/collections/all'
		})
	});
})()


$(document).ready(function () {
  var sections = new slate.Sections(),
    $html = $('html'),
    $body = $('body'),
    $allPopups = $('.popup'),
    $overlay = $('.overlay'),
    $miniCart = $('.mini-cart'),
    $mediaQuery = $('.mq'),
    $header = $('.full-header'),
    $mainMenuItems = $('.site-nav--has-submenu'),
    $submenus = $('.site-nav__submenu'),
    $subMenuItems = $('.site-nav--has-subsubmenu'),
    $mobileNav = $('.mobile-nav'),
    $toggleNav = $('a.toggle-nav'),
    $slideOutSearch = $('.slide-out-search'),
    $currencyConverter = $('.currency-converter'),
    headerHeight = parseInt($body.css('padding-top'), 10),
    resizeTimer,
    scrollTimer;
  sections.register('product', theme.Product);
  sections.register('product-recommendations', theme.ProductRecommendations);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));
  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';
  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper'
  });

  // Target iframes to make them responsive
  var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';
  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
  function toInches(n) {
    var val = n * 0.393701;
    return Math.round(val * 10) / 10;
  }
  function checkMediaQuery() {
    if ($mediaQuery.width() > 4) {
      slate.browserWidth = 'xxlarge';
    } else if ($mediaQuery.width() > 3) {
      slate.browserWidth = 'xlarge';
    } else if ($mediaQuery.width() > 2) {
      slate.browserWidth = 'large';
    } else if ($mediaQuery.width() > 1) {
      slate.browserWidth = 'medium';
    } else {
      slate.browserWidth = 'small';
    }
  }
  checkMediaQuery();
  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  function setViewportHeight() {
    if (isMobile()) {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      var vh = document.documentElement.clientHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  }
  setViewportHeight();
  function onResize() {
    checkMediaQuery();
    setViewportHeight();
  }

  // Update media query on window resize
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(onResize, 400);
  });

  // Currency
  $currencyConverter.find('.currency-list li').on('click', function () {
    var newCurrency = $(this).data('value');
    $currencyConverter.find('select').val(newCurrency);
    $currencyConverter.submit();
  });
  $body.on('click', 'a.toggle-currency', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Don't count this as a body click because it will close the menu

    $currencyConverter.removeClass('active');
    $html.removeClass('nav-shown');
  });

  // Sticky nav
  function stickyNav() {
    if ($(window).scrollTop() > headerHeight) {
      $body.addClass('sticky-nav');
    } else {
      $body.removeClass('sticky-nav');
    }
  }
  $(window).on('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(stickyNav, 50);
  });

  // Show/hide dropdown menus
  $mainMenuItems.children('a').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Don't count this as a body click because it will close the menu

    var $submenuParent = $(this).parent();
    checkMediaQuery();
    // Only run on desktop
    if (slate.browserWidth == 'xlarge' || slate.browserWidth == 'xxlarge') {
      if ($submenuParent.hasClass('active')) {
        $submenuParent.removeClass('active');
        $html.removeClass('nav-shown');
      } else {
        $submenuParent.addClass('active');
        $html.addClass('nav-shown');
        $mainMenuItems.not($submenuParent).removeClass('active');
        $html.removeClass('mini-cart-shown slide-out-search-shown');
      }
      // Only run on mobile
    } else {
      $submenuParent.toggleClass('active');
      $mainMenuItems.not($submenuParent).removeClass('active');
    }
  });

  // Show/hide submenus on mobile
  $subMenuItems.children('a').on('click', function (e) {
    checkMediaQuery();
    if (slate.browserWidth == 'small' || slate.browserWidth == 'medium' || slate.browserWidth == 'large') {
      e.preventDefault();
      var $subsubmenuParent = $(this).parent();
      $subsubmenuParent.toggleClass('active');
      $subMenuItems.not($subsubmenuParent).removeClass('active');
    }
  });

  // Show/hide main nav panel on mobile
  $toggleNav.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Don't count this as a body click because it will close the nav

    if ($html.hasClass('mobile-nav-shown')) {
      $html.removeClass('mobile-nav-shown nav-shown');
    } else {
      $html.addClass('mobile-nav-shown nav-shown');
      $html.removeClass('mini-cart-shown slide-out-search-shown');
    }
  });

  // Toggle search
  $body.on('click', 'a.toggle-search', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Don't count this as a body click because it will close the search

    if ($html.hasClass('slide-out-search-shown')) {
      $html.removeClass('slide-out-search-shown');
      $html.removeClass('nav-shown');
    } else {
      $html.addClass('slide-out-search-shown');
      $html.removeClass('mobile-nav-shown mini-cart-shown');
      $slideOutSearch.find('input').focus();
      checkMediaQuery();
      // Only run on desktop
      if (slate.browserWidth == 'xlarge' || slate.browserWidth == 'xxlarge') {
        $mainMenuItems.removeClass('active');
        // Only run on mobile
      } else {
        $html.addClass('nav-shown');
      }
    }
  });

  // Close popups on button click
  $allPopups.on('click', 'a.close', function (e) {
    e.preventDefault();
    $html.removeClass('popup-shown');
    $allPopups.removeClass('shown');
    $overlay.removeClass('shown');
    slate.popUpShown = false;
  });

  // Close popups on overlay click
  $body.on('click', '.overlay', function () {
    if (slate.popUpShown) {
      $html.removeClass('popup-shown');
      $allPopups.removeClass('shown');
      $overlay.removeClass('shown');
      slate.popUpShown = false;
    }
  });

  // Close popups on escape key press
  $(document).on('keydown', function (e) {
    // If escape key pressed
    if (e.keyCode == 27) {
      if (slate.popUpShown) {
        $html.removeClass('popup-shown');
        $allPopups.removeClass('shown');
        $overlay.removeClass('shown');
        slate.popUpShown = false;
      }
    }
  });

  // Hide dropdowns on body click
  $body.on('click touchstart', function (e) {
    var removeNavShown = true;

    // Don't close mini cart if user has clicked inside it or on toggle icon click
    if (!($(e.target).closest($miniCart).length || $(e.target).closest('a.toggle-mini-cart').length || $(e.target).closest('.popup-sign-in').length)) {
      $html.removeClass('mini-cart-shown');
    }

    // Check if click is inside the slide-out search OR on the toggle button
    if (!($(e.target).closest('.slide-out-search').length || $(e.target).closest('a.toggle-search').length)) {
      $html.removeClass('slide-out-search-shown');
    } else {
      removeNavShown = false;
    }
    checkMediaQuery();
    // Only run on mobile
    if (slate.browserWidth == 'small' || slate.browserWidth == 'medium' || slate.browserWidth == 'large') {
      // Don't close mobile nav on clicks inside it or on toggle icon click
      if (!($(e.target).closest($mobileNav).length || $(e.target).closest($toggleNav).length)) {
        $html.removeClass('mobile-nav-shown');
      } else {
        removeNavShown = false;
      }
      // Only run on desktop
    } else {
      // Don't close menu on clicks inside it
      if (!$(e.target).closest($submenus).length) {
        $mainMenuItems.removeClass('active');
      } else {
        removeNavShown = false;
      }
    }
    if (removeNavShown) {
      $html.removeClass('nav-shown');
    }
  });
  var $announcementsSlideshow = $('.announcements-slideshow .announcement');
  if ($announcementsSlideshow.length > 0) {
    let currentIndex = 0;
    function showNextAnnouncement() {
      $announcementsSlideshow.hide();
      $announcementsSlideshow.eq(currentIndex).show();
      currentIndex = (currentIndex + 1) % $announcementsSlideshow.length;
    }

    // Initially show the first announcement
    showNextAnnouncement();

    // Set interval to show the next announcement every 10 seconds
    setInterval(showNextAnnouncement, 10000);
  }
  $body.on('click', '.accordion-toggle', function (e) {
    var $this = $(this),
      $accordion = $this.closest('.accordion'),
      accordionActive = true,
      href = $this.attr('href');
    if ($accordion.hasClass('only-medium-down')) {
      checkMediaQuery();
      if (slate.browserWidth != 'small') {
        accordionActive = false;
      }
    }
    if ($accordion.hasClass('only-xlarge-down')) {
      checkMediaQuery();
      if (slate.browserWidth == 'xlarge' || slate.browserWidth == 'xxlarge') {
        accordionActive = false;
      }
    }
    if (accordionActive || href == '#') {
      e.preventDefault();
    }
    if (accordionActive) {
      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $accordion.find('.accordion-content').slideUp();
      } else {
        $this.addClass('active');
        $accordion.find('.accordion-content').slideDown();

        // Close other accordions
        $accordion.parent().parent().find('.accordion').not($accordion).find('.accordion-toggle').removeClass('active').closest('.accordion').find('.accordion-content').slideUp();
      }
    }
  });
  $body.on('click', '.tab-nav li', function () {
    var $this = $(this),
      $tabContent = $this.closest('.tabs').find('.tab-content'),
      index = $this.index();
    if (!$this.hasClass('active')) {
      $this.addClass('active').siblings().removeClass('active');
      $tabContent.removeClass('active').eq(index).addClass('active');
      var $productSliderSlideshow = $tabContent.eq(index).find('.product-slider-slideshow'),
        $wardrobeSliderSlideshow = $tabContent.eq(index).find('.wardrobe-slider-slideshow');

      // Reinitialize sliders
      if ($productSliderSlideshow.length || $wardrobeSliderSlideshow.length) {
        window.dispatchEvent(new Event('resize'));
      }
    }
  });

  // Set up scroll carousels
  document.querySelectorAll('.carousel').forEach(function (carousel) {
    return new ScrollCarousel(carousel).init();
  });

  /*================ AJAX Cart ================*/
  ajaxCart.init({
    showPopup: false,
    miniCart: true,
    formSelector: '.add-to-cart-form',
    cartContainer: '#cart-container',
    cartSidebarContainer: '#cart-sidebar-container',
    miniCartContainer: '#mini-cart-container',
    addToCartSelector: '[data-add-to-cart]',
    cartCountSelector: '.cart-item-count',
    cartImgSize: '120x180_crop_center',
    // Shopify size: e.g. '300x200_crop_center'
    cartImgSrcset: ['120x180_crop_center', '200x300_crop_center', '400x600_crop_center'],
    // Array of Shopify sizes (width required for srcset)
    miniCartImgSize: '120x180_crop_center',
    miniCartImgSrcset: ['120x180_crop_center', '200x300_crop_center', '400x600_crop_center'],
    popupImgSize: '200x',
    popupImgSrcset: ['200x', '400x']
  });
  $body.on('click', 'a.toggle-mini-cart', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Don't count this as a body click because it will close the cart

    if ($html.hasClass('mini-cart-shown')) {
      $html.removeClass('mini-cart-shown');
      $overlay.removeClass('shown');
      slate.popUpShown = false;
    } else {
      ajaxCart.loadMini();
      $html.removeClass('mobile-nav-shown nav-shown slide-out-search-shown');
      checkMediaQuery();
      // Only run on desktop
      if (slate.browserWidth == 'xlarge' || slate.browserWidth == 'xxlarge') {
        $mainMenuItems.removeClass('active');
      }

      // Only run on mobile
      if (slate.browserWidth == 'small') {
        $overlay.addClass('shown');
        setTimeout(function () {
          slate.popUpShown = true;
        }, 300);
      }
    }
  });

  /*================ Home Page ================*/
  if ($body.hasClass('template-index')) {
    // Get user data (Moochi Money)
    // If user logged in
    if (userInfo.id) {
      var options = {
        type: 'GET',
        url: '/a/ps/' + userInfo.id + '/status',
        timeout: 0,
        headers: {
          'custom-token': userInfo.token
        }
      };
      $.ajax(options).done(function (response) {
        if (response.message == 'success') {
          if (typeof response.data.loyalty[0] !== 'undefined') {
            var availablePoints = response.data.loyalty[0].available_points,
              nextVoucher = Math.ceil(response.data.loyalty[0].spend_for_next_reward);
          } else {
            var availablePoints = 0,
              nextVoucher = 600;
          }
          var $moochiMoneyBalance = $('.dynamic-mm-balance'),
            $moochiMoneyVoucher = $('.dynamic-mm-voucher');
          if ($moochiMoneyBalance.length) {
            $moochiMoneyBalance.text(availablePoints);
          }
          if ($moochiMoneyVoucher.length) {
            $moochiMoneyVoucher.text(nextVoucher);
          }
        }
      });
    }

    // Dynamic headings based on the time of day
    var $welcomeHeading = $('.welcome .dynamic-heading');
    if ($welcomeHeading.length) {
      var startHours = $welcomeHeading.data('start').toString().split('|'),
        titles = $welcomeHeading.data('title').split('|'),
        currentHour = new Date().getHours(),
        titleOutput = '';
      if (titles.length) {
        // Use the last hour as the default (late night is also early morning)
        titleOutput = titles[titles.length - 1];

        // Find the title which relates to the current hour
        for (i = 0; i < startHours.length; i++) {
          var loopHour = parseInt(startHours[i], 10);
          if (currentHour >= loopHour) {
            titleOutput = titles[i];
          }
        }
        $welcomeHeading.html(titleOutput);
      }
    }
    var $popupWelcome = $('.popup-welcome');

    // Show popup if it hasn't been shown yet
    if ($popupWelcome.length) {
      if (!localStorage.getItem('welcome_popup_shown')) {
        if (slate.browserWidth == 'small') {
          $html.addClass('popup-shown');
          $allPopups.removeClass('shown');
          $popupWelcome.addClass('shown');
          $overlay.addClass('shown');
          setTimeout(function () {
            slate.popUpShown = true;
          }, 300);
          localStorage.setItem('welcome_popup_shown', true);
        } else {
          // Show after 10s on desktop
          setTimeout(function () {
            $popupWelcome.addClass('shown');
            localStorage.setItem('welcome_popup_shown', true);
          }, 10000);
        }
      }
    }
  }

  /*================ Product Page ================*/
  if ($body.hasClass('template-product')) {
    // Toggle between 1/2 column product view
    var $productOuter = $('.product-outer'),
      $toggleProductView = $('a.toggle-product-view'),
      $productImageZoom = $('.product-image-zoom'),
      $sizeGuidePopup = $('.popup-size-guide'),
      $storePopup = $('.popup-store'),
      $sizeConversion = $('.size-conversion'),
      $sizeConversionLinks = $sizeConversion.find('.size-conversion-links a'),
      $sizeGuideTable = $sizeConversion.find('table');
    if (localStorage.getItem('product_view') == 1) {
      $productOuter.removeClass('two-product-view');

      // Reinitialize slider
      window.dispatchEvent(new Event('resize'));
    }
    $toggleProductView.on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      if ($this.hasClass('two-product-toggle')) {
        $productOuter.addClass('two-product-view');
        localStorage.setItem('product_view', 2);
      } else {
        $productOuter.removeClass('two-product-view');
        localStorage.setItem('product_view', 1);
      }

      // Reinitialize slider
      window.dispatchEvent(new Event('resize'));
    });
    if ($productImageZoom.length) {
      if (slate.browserWidth == 'large' || slate.browserWidth == 'xlarge' || slate.browserWidth == 'xxlarge') {
        $productImageZoom.each(function () {
          var $this = $(this);
          $this.zoom({
            on: 'click',
            url: $this.data('zoom'),
            magnify: $this.data('magnify'),
            onZoomIn: function () {
              $productImageZoom.not($(this).closest('.product-image-zoom')).trigger('zoom.off');
            }
          });
        });
      }
    }
    $('a.trigger-size-guide-popup').on('click', function (e) {
      e.preventDefault();
      $html.addClass('popup-shown');
      $allPopups.removeClass('shown');
      $sizeGuidePopup.addClass('shown');
      $overlay.addClass('shown');
      setTimeout(function () {
        slate.popUpShown = true;
      }, 300);
    });
    $('a.trigger-store-popup').on('click', function (e) {
      e.preventDefault();
      $html.addClass('popup-shown');
      $allPopups.removeClass('shown');
      $storePopup.addClass('shown');
      $overlay.addClass('shown');
      setTimeout(function () {
        slate.popUpShown = true;
      }, 300);
    });
    $sizeConversionLinks.on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      $this.addClass('active').siblings().removeClass('active');
      if ($this.data('measurement') == 'inch') {
        $this.closest($sizeConversion).addClass('show-in');
      } else {
        $this.closest($sizeConversion).removeClass('show-in');
      }
    });
    $sizeGuideTable.find('td').each(function () {
      var $this = $(this),
        val = parseInt($this.text());
      $this.wrapInner('<span class="cm"></span>');
      $this.append('<span class="in">' + toInches(val) + '</span>');
    });
  }

  // Add upsell product when clicked in cart or mini cart
  $body.on('click', 'a.upsell-add', function (e) {
    e.preventDefault();
    var $this = $(this),
      variantID = $(this).data('id');
    item = null;
    if (variantID) {
      item = {
        id: variantID,
        quantity: 1
      };
      $this.addClass('disabled');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: item,
        dataType: 'json'
      }).done(function () {
        // On success
        $this.removeClass('disabled').text(theme.strings.addedToCart);

        // Update cart with new product
        ajaxCart.load();
      }).fail(function () {
        // On fail
        alert('Error adding product to your bag, please try again.');
        $this.removeClass('disabled');
      });
    }
  });

  /*================ FAQs Page ================*/
  if ($body.hasClass('template-faqs')) {
    var $allQuestions = $('.main-content .accordion');
    $('form.search-faqs').on('submit', function (e) {
      e.preventDefault();
      var $this = $(this),
        $noResults = $this.find('.form-error'),
        searchKeyword = $this.find('input').val(),
        resultsFound = false;
      $noResults.addClass('hide');
      $allQuestions.removeClass('hide');
      if (searchKeyword) {
        $allQuestions.addClass('hide');

        // Look through all questions to find the search keyword
        $allQuestions.each(function () {
          var $this = $(this),
            content = $this.text();

          // If results found
          if (content.indexOf(searchKeyword) !== -1) {
            $this.removeClass('hide');
            resultsFound = true;
          }
        });

        // If no results found
        if (!resultsFound) {
          $noResults.removeClass('hide');
          $allQuestions.removeClass('hide');
        }
      }
    });
  }

  /**
   * account > accept marketing
   */

  if ($body.hasClass('template-register')) {
    $('#marketing_check').on('change', el => {
      if ($(el.currentTarget).val() === 'true' || $(el.currentTarget).val() === true) {
        $(el.currentTarget).val(false);
        $('#marketing').val(false);
      } else {
        $(el.currentTarget).val(true);
        $('#marketing').val(true);
      }
    });
  }

  // After login redirect to /cart page when customer login from cart page
  $('.moochi-money-login a').on('click', () => {
    localStorage.setItem('prev_page', '/cart');
  });
  if ($body.hasClass('template-account') && localStorage.getItem('prev_page')) {
    window.location.href = localStorage.getItem('prev_page');
    localStorage.removeItem('prev_page');
  }

  // reviews slider element
  const reviewsSliderEl = $('.reviews-quotes-slider');
  // reviews slider options
  const reviewsSliderOptions = {
    infinite: false,
    fade: true,
    draggable: false
  };
  // run when reviews slider first load
  reviewsSliderEl.on('init', function () {
    // remove load-hidden class after load
    reviewsSliderEl.removeClass("load-hidden");
  });
  const reviewsSlider = reviewsSliderEl.slick(reviewsSliderOptions);

  // Staff favourites slider element
  const staffFavouritesEl = $('.section-staff-favourites__carousel');
  const staffFavouritesOptions = {
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 990,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }]
  };
  staffFavouritesEl.on('init', function () {
    staffFavouritesEl.removeClass("load-hidden");
  });
  const staffFavouritesSlider = staffFavouritesEl.slick(staffFavouritesOptions);
  const staffPopupItems = document.querySelectorAll('.section-staff-favourites__carousel-item');
  staffPopupItems.forEach(item => {
    item.addEventListener('click', () => {
      const popup = document.querySelector('.' + item.dataset.popup);
      popup.classList.add("active");
      popup.addEventListener('click', event => {
        if (event.target.matches('.staff-favourites__popup-backdrop, .staff-popup-close')) {
          popup.classList.remove("active");
        }
      });
    });
  });
});

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}